import React, {useMemo} from 'react';
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";
import SelectCustom from '@ui/select/selectCustom/SelectCustom';
import {STATUSES_SINGLE_VOYAGES_RUNS} from "@containers/singleVoyage/select/selectStatusVoyage/constants";
import {useTranslation} from "react-i18next";

interface IProps {
    value: VoyageStatusSingleVoyage,
    onChange: (value: VoyageStatusSingleVoyage) => void
    error?: boolean,
    errorMessage?: string,
    label?:string
}

const SelectStatusSingleVoyageRuns = ({
                                          value,
                                          onChange,
                                          errorMessage,
                                          label,
                                          error
                                      }: IProps) => {

    const {t} = useTranslation()

    const dataSelect = useMemo(() => {
        return STATUSES_SINGLE_VOYAGES_RUNS.map((item) => {
            return {
                value: item.value,
                label: t(item.label)
            }
        })
    }, [t])
    return (
        <SelectCustom
            value={value}
            onChange={onChange}
            error={error}
            errorMessage={errorMessage}
            data={dataSelect}
            label={label}
        />
    );
};

export default SelectStatusSingleVoyageRuns;